import { createAsyncThunk } from "@reduxjs/toolkit";
import schoolService from "../../../api/services/school";

export const fetchSchools = createAsyncThunk("school/fetch", async () => {
  const schools = await schoolService.fetchSchools();
  return schools;
});

export const fetchSchool = createAsyncThunk("school/fetchSchool", async () => {
  const school = await schoolService.fetchSchool();
  return school;
});

export const editSchool = createAsyncThunk(
  "school/editSchool",
  async (requestData) => {
    const {
      address,
      city,
      zipCode,
      phoneNumber,
      state,
      name,
      logoUrl,
      alertAdmins,
      alertMinutes,
    } = requestData;
    let formData = new FormData();

    if (logoUrl) {
      formData.append("file", logoUrl);
    }

    formData.append("address", address);
    formData.append("city", city);
    formData.append("zipCode", zipCode);
    formData.append("phoneNumber", phoneNumber);
    formData.append("name", name);
    formData.append("state", state);
    formData.append("alertAdmins", alertAdmins);
    formData.append("alertMinutes", alertMinutes);

    const school = await schoolService.editSchool(formData);
    return school;
  }
);
